import { h } from "@stencil/core";
export class ChStepList {
    el;
    ulStep;
    render() {
        return (h("div", { class: "step-container" }, h("ul", { ref: el => (this.ulStep = el) }, h("slot", null))));
    }
    static get is() { return "ch-step-list"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["ch-step-list.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ch-step-list.css"]
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=ch-step-list.js.map
